import React from 'react';
import { useGetTicketMessages } from '../hooks/ticketQueries';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import Message from './Message';
import whoisCreator from '../lib/whoIsCreator';
import { L } from '../../../lib/i18n';
import MessageDivider from '../../../components/Message/MessageDivider';
import { colors } from '../../../components/Shared/Style/colors';
import { style } from '../../../components/Shared/Style';
import styled from '@emotion/styled';
import EmptyState from '../../../components/EmptyStateCommunity/EmptyStateCommunity';

const ChatWrapper = styled.div({
    display: 'flex',
    gap: '1rem',
    height: '60vh',
    maxHeight: '60vh',
    overflowY: 'auto',
    maxWidth: '100%',
    flexDirection: 'column-reverse',
    padding: '1rem 0.4rem',
    backgroundColor: colors.inputBackground,
    borderRadius: style.roundCornerSize.small
});

dayjs.extend(isBetween);

type Props = {
    messages: NonNullable<ReturnType<typeof useGetTicketMessages>['data']>;
    assingeesIds: number[];
    profileId?: number;
    lastRead: string;
};
const CustomerMessages = ({ profileId, assingeesIds, messages, lastRead }: Props) => {
    return (
        <ChatWrapper>
            {messages?.map((message, index, messages) => {
                const nextMessage = messages[index + 1];
                const isLastReadBetween = dayjs(lastRead).isBetween(message.created_at, nextMessage?.created_at);

                if (isLastReadBetween && nextMessage) {
                    return (
                        <React.Fragment key={message.id}>
                            <Message
                                key={message.id}
                                message={message}
                                messageSender={whoisCreator(message.created_by, profileId, assingeesIds)}
                            />
                            <MessageDivider>{L('last_viewed')}</MessageDivider>
                        </React.Fragment>
                    );
                }
                return (
                    <Message
                        key={message.id}
                        messageSender={whoisCreator(message.created_by, profileId, assingeesIds)}
                        message={message}
                    />
                );
            })}
            {messages?.length === 0 && (
                <EmptyState>
                    <EmptyState.Title>{L('no_messages')}</EmptyState.Title>
                    <EmptyState.Description>{L('no_messages_description')}</EmptyState.Description>
                </EmptyState>
            )}
        </ChatWrapper>
    );
};

export default CustomerMessages;
